import React, { useState } from 'react'
import Modal from '../../shared/modal'
import PlusMinusWrapper from '../../shared/plusMinusWrapper'
import Icon from '../../shared/icon'
import { ReplenishmentOrderAction } from '../types'
import { t } from 'src/i18n'

type OilMode = 'view' | 'edit' | 'complete'

const scope = 'replenishment.oil'

const ReplenishmentCompletedModalContent = ({ closeModal, amount, toggleSidebar }) => {

  const openBasket = () => {
    toggleSidebar(true)
    closeModal()
  }

  return (
    <div className='bowl-replenishment-complete'>
      <div className='title-icon'>
        <Icon name='replace'/>
      </div>
      <div className='heavy-text'>Oil replenishment</div>
      <br/>
      <p>
      {t('oil_message', { scope, amount: amount })}
      </p>
      <div className='buttons'>
        <button className='btn btn-secondary' onClick={openBasket}>{t('replenishment.replenishment_modal.go_to_basket')}</button>
        <button className='btn btn-primary' onClick={closeModal}>{t('replenishment.replenishment_modal.continue')}</button>
      </div>
    </div>
  )
}


export const OilReplenishmentModal = ({
  oilLevel, closeModal, draftReplenishmentOrder, updateCart, toggleSidebar, weightScale
}) => {
  const [mode, setMode] = useState<OilMode>('view')
  const [replenishmentAmount, setReplenishmentAmount] = useState(oilLevel.oil_remaining || 0)

  const amountLeft = oilLevel.oil_remaining
  const amountToReplenish = oilLevel.oil_capacity - oilLevel.oil_remaining

  const addToReplenishmentOrder = () => {
    const oilReplenishment = {
      amount: amountToReplenish
    }
    updateOilReplenishment(oilReplenishment)
  }

  const oilAlreadyReplenished = () => {
    return !!draftReplenishmentOrder.oilReplenishment
  }

  const replenishedContainer = () => {
    return draftReplenishmentOrder.oilReplenishment
  }

  const updateOilReplenishment = (oilReplenishment) => {
    if(oilAlreadyReplenished()) {
      return
    } else {
      updateCart({...draftReplenishmentOrder, oilReplenishment: oilReplenishment}, ReplenishmentOrderAction.ADD_ITEM)
    }
  }

  const headerContent = () => {
    if(oilAlreadyReplenished())  {
      return (
        <>
          <h3 className='header'>{t('oil_tank', { scope })}</h3>
          <span className='replenishment-header-text'>to refill</span>
        </>
      )
    }

    return (<h3 className='header'>{t('oil_tank', { scope })}</h3>)
  }

  const amountText = () => {
    if (oilAlreadyReplenished()) {
      return t('stock_control.oil_status.marked_for_replenishment')
    }
    return t(`stock_control.oil_status.${oilLevel.oil_status}`)
    if(!!oilLevel) {
      return `${amountLeft} / ${oilLevel.oil_capacity}`
    } else {
      return '0 / 0'
    }
  }

  const amount = () => {
    return (
      <span>{amountText()}</span>
    )
  }

  return (
    <>
      <Modal onClose={closeModal}
      headerContent={ mode === 'complete' ? null : headerContent()}>
      <div className='container-modal show'>
      {mode != 'complete' &&
        <>
          <div className='product-info'>
            <div className="plates-icon-container">
              <Icon name='oil_tank' color='white'/>
            </div>
            <div className="product-content">
              {amount()}
            </div>
          </div>
          <div className='buttons'>
            <button className='btn btn-secondary' onClick={closeModal}>{t('cancel')}</button>
            {mode === 'view' && <button className='btn btn-primary btn-refill' onClick={() => {addToReplenishmentOrder(); setMode('complete')}}>{t('refill_tank', { scope })}</button>}
            {mode === 'edit' && <button className='btn btn-primary' onClick={() => {addToReplenishmentOrder(); setMode('complete')}}>{t('save')}</button>}
          </div>
        </>
      }
      {mode === 'complete' &&
        <ReplenishmentCompletedModalContent
          closeModal={closeModal}
          toggleSidebar={toggleSidebar}
          amount={replenishmentAmount}
        />
      }
      </div>
    </Modal>
    </>
  )
}
